export default __webpack_public_path__ + "static/media/icon-hexagon.cb73e6df.svg";